import { Component, OnInit, ViewContainerRef, ChangeDetectorRef } from '@angular/core';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';
import { Observable } from 'rxjs/Observable';

import { plainToClass } from 'class-transformer';

import { ApplicationValue } from 'app/services/warmup/application-type.model';
import { WarmUpService, ApplicationTypeConstants } from 'app/services/warmup/warmup.service';
import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';
import { TrackingConstants } from 'app/shared/services/tracking/tracking-constants.service';

import { RiskClass } from 'app/shared/models/risk-class.enums'
import { RiskProfile } from 'app/shared/models/risk-profile.model';
import { RiskProfileResponse } from 'app/shared/models/risk-profile-response.model';
import { RiskProfileScore } from 'app/shared/models/risk-profile-score.model';

import { RiskProfileService } from './risk-profile.service';

@Component({
  selector: 'risk-profile',
  providers: [RiskProfileService],
  templateUrl: './risk-profile.component.html',
})

/**
 * Component to show the Risk Profile Details.
 */
export class RiskProfileComponent implements OnInit {

  clientId: Number;
  options: any = {};
  riskScore = 0;
  applicableRules: Array<String> = [];
  riskProfileHistory: RiskProfile[] = [];
  currentProfile: RiskProfile;
  selectedProfile: RiskProfile;
  riskClassesList: Array<RiskClass> = [];
  selectedRiskClass: RiskClass;
  enteredRiskAnalysis: String;
  enteredMitigationPlan: String;
  isCurrentRiskProfileEditableFlag: Boolean = false;
  isCurrentRiskProfileInFinalState: Boolean = false;
  savingRiskProfile: boolean;

  constructor(
    private riskProfileService: RiskProfileService,
    public dialogRef: MdDialogRef<any>,
    private snackBarService: SnackBarService,
    private trackingService: TrackingService) { }

  ngOnInit() {
    this.riskClassesList.push(RiskClass.HIGH);
    this.riskClassesList.push(RiskClass.MEDIUM);
    this.riskClassesList.push(RiskClass.LOW);
    this.getRiskProfileScore();
    this.getRiskProfile();
  }

  getRiskProfileScore() {
    this.riskProfileService.getRiskProfileScore(this.clientId)
      .map(response => {
        return plainToClass(RiskProfileScore, response.arrResult as Object[]);
      })
      .subscribe(response => {
        this.options = {}
        this.applicableRules = response[0].applicableRules;
      }, err => {
        this.callSnackBarService(err, '');
      })
  }

  getRiskProfile() {
    this.riskProfileService.getRiskProfiles(this.clientId)
      .map(response => {
        return plainToClass(RiskProfileResponse, response.arrResult as Object[]);
      })
      .subscribe(response => {
        this.riskProfileHistory = response[0].riskProfileHistory;
        this.currentProfile = response[0].currentProfile;
        if (this.currentProfile != undefined) {
          this.selectedRiskClass = this.currentProfile.riskClass;
          this.isCurrentRiskProfileEditableFlag = this.isCurrentRiskProfileEditable();
          this.options = {}
          this.options['title'] = this.currentProfile.riskClass;
          this.riskScore = this.currentProfile.riskScore;
          this.enteredMitigationPlan = this.currentProfile.mitigationPlan;
          this.enteredRiskAnalysis = this.currentProfile.riskAnalysis;
          this.isCurrentRiskProfileInFinalState = this.checkIfCurrentRiskProfileInFinalState();
        }
        if (this.riskProfileHistory.length != 0) {
          this.selectedProfile = this.riskProfileHistory[0];
        }
      }, err => {
        this.callSnackBarService(err, '');
      })
  }

  onRowSelect(event) {
    this.selectedProfile = event.data;
  }

  isCurrentRiskProfileEditable(): boolean {
    if (this.currentProfile != undefined) {
      return this.currentProfile.status == 'DRAFT';
    } else {
      return false;
    }
  }

  checkIfCurrentRiskProfileInFinalState(): boolean {
    if (this.currentProfile != undefined) {
      return this.currentProfile.status == 'FINAL';
    } else {
      return false;
    }
  }

  addNewRiskProfile() {
    this.riskProfileHistory.unshift(this.currentProfile);
    this.currentProfile = Object.assign({}, this.currentProfile);
    this.currentProfile.lastUpdate = undefined;
    this.currentProfile.riskScore = undefined;
    this.currentProfile.riskProfileId = undefined;
    this.currentProfile.entryTime = new Date().getTime();
    this.currentProfile.status = 'DRAFT';
    this.isCurrentRiskProfileInFinalState = false;
  }

  submitRiskProfile() {
    if (this.currentProfile != null) {
      this.savingRiskProfile = true;
      this.currentProfile.riskClass = this.selectedRiskClass;
      this.currentProfile.riskAnalysis = this.enteredRiskAnalysis;
      this.currentProfile.mitigationPlan = this.enteredMitigationPlan;
      if (this.currentProfile.riskProfileId == undefined) {
        this.addSubscriberToHandleRiskProfileUpdates(this.riskProfileService.addRiskProfile(this.currentProfile),
          MessageService.ADD_RISK_PROFILE_SUCCES);
      } else {
        this.addSubscriberToHandleRiskProfileUpdates(this.riskProfileService.updateRiskProfile(this.currentProfile),
          MessageService.SUBMIT_RISK_PROFILE_SUCCES);
      }
    }
  }

  addSubscriberToHandleRiskProfileUpdates(observable: Observable<any>, successMessage) {
    observable.subscribe(response => {
      this.savingRiskProfile = false;
      if (response.flagResult) {
        this.dialogRef.close(response.arrResult[0]);
      }
      this.trackingService
        .emitEvent(
        TrackingConstants.RISK_PROFILE_MANAGEMENT,
        TrackingConstants.PERFORM_SUBMIT_RISK_PROFILE,
        TrackingConstants.SUCCESS, 1);
      this.callSnackBarService(response, successMessage);
    },
      err => {
        this.savingRiskProfile = false;
        this.trackingService
          .emitEvent(
          TrackingConstants.RISK_PROFILE_MANAGEMENT,
          TrackingConstants.PERFORM_SUBMIT_RISK_PROFILE,
          TrackingConstants.FAILURE, 0);
        this.callSnackBarService(err, successMessage);
      }
    );
  }

  callSnackBarService(response, successMsg) {
    this.snackBarService.showStatus(response, successMsg, MessageService.ERROR_MESSAGE);
  }

  riskClassChanged() {
    const riskClassScore = {
      'High': 100,
      'Medium': 50,
      'Low': 0,
    };
    this.riskScore = riskClassScore[this.selectedRiskClass];
  }
}



// WEBPACK FOOTER //
// ./src/app/clients/client/header/riskprofile/risk-profile.component.ts